import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box, Button, Typography } from '@saviynt/design-system';

import {
  resetDynamicSortDetails,
  setActiveTab,
  setAppliedRoleFilters,
  setSearchText,
} from '../../../redux/certlist/action';
import { getMessageKey } from '../../../utils/utils';
import { CERTS_LIST_ALL_TAB } from '../constant';

import {
  NO_RECORDS_FILTERS_AND_SEARCH_QUERY_MSGS,
  NO_RECORDS_MSGS,
} from './constant';

import './CertsListNoRecordsFound.css';

function CertsListNoRecordsFound() {
  const [details, setDetails] = useState(null);
  const dispatch = useDispatch();
  const intl = useIntl();

  const {
    core: { isAdminLogin },
    tabs: { activeTab },
    viewControls: {
      searchText,
      appliedRoleFilters,
      dynamicSortFilter: { sortByColumn, sortDirection },
    },
  } = useSelector((state) => state?.certifications?.list);
  const { messages } = useSelector((state) => state?.user);

  const clearFilters = () => {
    dispatch(resetDynamicSortDetails());
    dispatch(setAppliedRoleFilters(null));
  };

  const clearSearch = () => {
    dispatch(setSearchText(''));
  };

  const clickOnViewAllCertificatons = () => {
    dispatch(setActiveTab(CERTS_LIST_ALL_TAB));
  };

  const goToConfigureCampaign = () => {
    // alert('redirect to configure campaign page'); WIP
  };

  useEffect(() => {
    let detailsObj = {};

    if (searchText?.length > 0) {
      detailsObj = NO_RECORDS_FILTERS_AND_SEARCH_QUERY_MSGS.SEARCH_QUERY;

      if (detailsObj?.buttonText) {
        detailsObj.buttonAction = clearSearch;
      }

      setDetails(detailsObj);

      return;
    }

    if (
      (appliedRoleFilters && appliedRoleFilters.length > 0) ||
      (sortByColumn && sortDirection)
    ) {
      detailsObj = NO_RECORDS_FILTERS_AND_SEARCH_QUERY_MSGS.FILTER;

      if (detailsObj?.buttonText) {
        detailsObj.buttonAction = clearFilters;
      }

      setDetails(detailsObj);

      return;
    }

    if (isAdminLogin) {
      const noRecordDetails = NO_RECORDS_MSGS[activeTab]?.find(
        (element) => element.isAdmin
      );

      detailsObj = noRecordDetails;

      if (activeTab === CERTS_LIST_ALL_TAB && detailsObj?.buttonText) {
        detailsObj.buttonAction = goToConfigureCampaign;
      }

      if (detailsObj?.buttonText) {
        detailsObj.buttonAction = clickOnViewAllCertificatons;
      }

      setDetails(detailsObj);

      return;
    }

    if (NO_RECORDS_MSGS[activeTab]) {
      const noRecordDetails = NO_RECORDS_MSGS[activeTab]?.find(
        (element) => !element.isAdmin
      );

      detailsObj = noRecordDetails;

      if (detailsObj?.buttonText) {
        detailsObj.buttonAction = clickOnViewAllCertificatons;
      }

      setDetails(detailsObj);
    }
  }, []);

  if (!details) {
    return <Box />;
  }

  return (
    <Box className='CertsListNoRecordsFound'>
      <Typography
        kind='h2'
        desktop='h2-d'
        mobile='h2-d'
        className='CertsListNoRecordsFound-primaryText'>
        {messages[details.primaryText] ||
          localize(intl, getMessageKey(details.primaryText))}
      </Typography>
      <Typography
        kind='body2'
        desktop='body2-d'
        mobile='body2-d'
        className='CertsListNoRecordsFound-secondaryText'>
        {messages[details.secondaryText] ||
          localize(intl, getMessageKey(details.secondaryText))}
      </Typography>
      {details?.buttonText && (
        <Button
          type='button'
          kind='filled'
          size='medium'
          onClick={details.buttonAction}>
          {messages[details.buttonText] ||
            localize(intl, getMessageKey(details.buttonText))}
        </Button>
      )}
    </Box>
  );
}

export default CertsListNoRecordsFound;
